import { SellerUnitsAndProjectsOne } from "@/types/sup";
import { toSentenceCase } from "@/utils/string/to-sentence-case";
import Image from "next/image";

interface InteriorsProps {
	supOne: SellerUnitsAndProjectsOne;
}

export function Interiors({ supOne }: InteriorsProps) {
	const interiors = supOne.spaceSummary?.interiors || [];

	if (!interiors.length) {
		return null;
	}

	return (
		<div>
			<div className="grid grid-cols-2 @4xl:grid-cols-4 gap-4">
				{interiors.map((item, index) => {
					const spaces = item.space || [];
					const spacesText = spaces.map(toSentenceCase).join(", ");

					return (
						<div key={`interior-${index}`} className="flex flex-col items-center text-center">
							<div className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center mb-2">
								<Image
									src="/images/furnishings/interior-design.svg"
									alt={item.name}
									width={24}
									height={24}
									className="text-gray-600"
								/>
							</div>
							<div className="text-xs font-medium text-gray-900 truncate w-full" title={item.name}>
								{item.name}
							</div>
							{spaces.length > 0 && (
								<div className="text-xs text-gray-500 truncate w-full" title={spacesText}>
									({spacesText})
								</div>
							)}
						</div>
					);
				})}
			</div>
		</div>
	);
}
